module.exports = __webpack_public_path__ + "img/list-detailstotal-questions.bf1fe0b6.svg";